// extracted by mini-css-extract-plugin
export default {"spacingHeading":"Login_spacingHeading__DGowv","spacingText":"Login_spacingText__GzlH5","spacingInput":"Login_spacingInput__CXeGQ","spacingButton":"Login_spacingButton__XpIya"};